import styled, { css } from 'styled-components';
import { Wrapper as FormButton } from 'components/Button/style';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;

    ${FormButton} {
      margin-bottom: 8px;

      &:disabled {
        background-color: ${theme.colors.neutralDark30};
        cursor: not-allowed;
      }

      @media (max-width: 576px) {
        margin-bottom: 0;
      }
    }
  `}
`;

export const Details = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Stripe = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.neutralDark60};
    font-size: 1.2rem;
    display: flex;
    align-items: center;

    > svg {
      color: ${theme.colors.neutralDark100};
      margin-right: 8px;
    }

    > img {
      margin-left: 4px;
    }
  `}
`;

export const ButtonWrapper = styled.div`
  margin-bottom: 8px;
`;
